var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c(
        "v-row",
        { staticClass: "px-16 pt-6" },
        [
          _c(
            "v-col",
            { staticClass: "pl-0", attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("img", {
                        staticClass: "arrow px-4 py-3",
                        attrs: { src: _vm.ic_back, id: "back-btn" },
                        on: { click: _vm.backToPrevPage },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-n4", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "back-lbl" }, [
                        _vm._v(_vm._s(_vm.backToLbl) + " "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "px-16 mb-12 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10", attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v(_vm._s(_vm.pageHeader)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-n5", attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("label", { staticClass: "page-sub-header" }, [
                        _vm._v(
                          "Get LTL carrier transit times between points in the United States and Canada by entering your Origin and Destination zip/postal codes and clicking on the search button. Canadian zip codes must be formatted i.e. L5T 2S3."
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "br-15 px-3 pb-5",
                          attrs: { elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-row",
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "label",
                                      { staticClass: "transit-search-header" },
                                      [_vm._v("Origin")]
                                    ),
                                  ]),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-combobox", {
                                        attrs: {
                                          items: _vm.countriesDll,
                                          label: "Country",
                                        },
                                        on: { change: _vm.origCountryChanged },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "prepend-inner",
                                            fn: function () {
                                              return [
                                                _c("img", {
                                                  staticClass: "mr-2 ml-2",
                                                  staticStyle: {
                                                    "margin-top": "4px",
                                                  },
                                                  attrs: {
                                                    width: "13",
                                                    src: _vm.ic_pin_blue,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value: _vm.selectedOrigCountry,
                                          callback: function ($$v) {
                                            _vm.selectedOrigCountry = $$v
                                          },
                                          expression: "selectedOrigCountry",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-combobox", {
                                        attrs: {
                                          items: _vm.origStatesDdl,
                                          label: "State/Province",
                                          clearable: "",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "prepend-inner",
                                            fn: function () {
                                              return [
                                                _c("img", {
                                                  staticClass: "mr-2 ml-2",
                                                  staticStyle: {
                                                    "margin-top": "4px",
                                                  },
                                                  attrs: {
                                                    width: "13",
                                                    src: _vm.ic_pin_blue,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value: _vm.selectedOrigState,
                                          callback: function ($$v) {
                                            _vm.selectedOrigState = $$v
                                          },
                                          expression: "selectedOrigState",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-text-field", {
                                        attrs: {
                                          placeholder: "City",
                                          maxlength: "32",
                                          icon: _vm.ic_pin_blue,
                                          "icon-slot": "inner",
                                          "icon-class": "mr-3 mt-1",
                                          "icon-width": "13",
                                          "icon-position": "left",
                                        },
                                        model: {
                                          value: _vm.origCity,
                                          callback: function ($$v) {
                                            _vm.origCity = $$v
                                          },
                                          expression: "origCity",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-text-field", {
                                        ref: "origPostalCode",
                                        attrs: {
                                          placeholder: "Zip/Postal Code",
                                          maxlength: "9",
                                          icon: _vm.ic_pin_blue,
                                          "icon-slot": "inner",
                                          "icon-class": "mr-3 mt-1",
                                          "icon-width": "13",
                                          "icon-position": "left",
                                          required: true,
                                        },
                                        model: {
                                          value: _vm.origPostalCode,
                                          callback: function ($$v) {
                                            _vm.origPostalCode = $$v
                                          },
                                          expression: "origPostalCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-divider", { staticClass: "my-7" }),
                              _c(
                                "v-row",
                                [
                                  _c("v-col", { attrs: { cols: "12" } }, [
                                    _c(
                                      "label",
                                      { staticClass: "transit-search-header" },
                                      [_vm._v("Destination")]
                                    ),
                                  ]),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-combobox", {
                                        attrs: {
                                          items: _vm.countriesDll,
                                          label: "Country",
                                        },
                                        on: { change: _vm.destCountryChanged },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "prepend-inner",
                                            fn: function () {
                                              return [
                                                _c("img", {
                                                  staticClass: "mr-2 ml-2",
                                                  staticStyle: {
                                                    "margin-top": "4px",
                                                  },
                                                  attrs: {
                                                    width: "13",
                                                    src: _vm.ic_pin_blue,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value: _vm.selectedDestCountry,
                                          callback: function ($$v) {
                                            _vm.selectedDestCountry = $$v
                                          },
                                          expression: "selectedDestCountry",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-combobox", {
                                        attrs: {
                                          items: _vm.destStatesDdl,
                                          label: "State/Province",
                                          clearable: "",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "prepend-inner",
                                            fn: function () {
                                              return [
                                                _c("img", {
                                                  staticClass: "mr-2 ml-2",
                                                  staticStyle: {
                                                    "margin-top": "4px",
                                                  },
                                                  attrs: {
                                                    width: "13",
                                                    src: _vm.ic_pin_blue,
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                        model: {
                                          value: _vm.selectedDestState,
                                          callback: function ($$v) {
                                            _vm.selectedDestState = $$v
                                          },
                                          expression: "selectedDestState",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-text-field", {
                                        attrs: {
                                          placeholder: "City",
                                          maxlength: "32",
                                          icon: _vm.ic_pin_blue,
                                          "icon-slot": "inner",
                                          "icon-class": "mr-3 mt-1",
                                          "icon-width": "13",
                                          "icon-position": "left",
                                        },
                                        model: {
                                          value: _vm.destCity,
                                          callback: function ($$v) {
                                            _vm.destCity = $$v
                                          },
                                          expression: "destCity",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-text-field", {
                                        ref: "destPostalCode",
                                        attrs: {
                                          placeholder: "Zip/Postal Code",
                                          maxlength: "9",
                                          icon: _vm.ic_pin_blue,
                                          "icon-slot": "inner",
                                          "icon-class": "mr-3 mt-1",
                                          "icon-width": "13",
                                          "icon-position": "left",
                                          required: true,
                                        },
                                        model: {
                                          value: _vm.destPostalCode,
                                          callback: function ($$v) {
                                            _vm.destPostalCode = $$v
                                          },
                                          expression: "destPostalCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { staticClass: "mt-16" },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        xl: "3",
                                        lg: "3",
                                        md: "4",
                                        sm: "12",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c("smart-calendar", {
                                        attrs: {
                                          label: "Pickup Date",
                                          iconClass: "mr-3 cal",
                                          "allowed-dates": _vm.allowedDates,
                                        },
                                        model: {
                                          value: _vm.pickupDate,
                                          callback: function ($$v) {
                                            _vm.pickupDate = $$v
                                          },
                                          expression: "pickupDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c("smart-btn", {
                                        attrs: {
                                          label: "Clear",
                                          type: "dismiss",
                                          width: "110",
                                        },
                                        on: { click: _vm.clearFilters },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "auto" } },
                                    [
                                      _c("smart-btn", {
                                        attrs: {
                                          type: "primary",
                                          label: "Search",
                                          width: 140,
                                          "icon-width": "14",
                                          "icon-class": "mr-2",
                                          "icon-position": "left",
                                          icon: _vm.ic_search_white,
                                        },
                                        on: { click: _vm.search },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("label", { staticClass: "transit-search-header" }, [
                        _vm._v("Information and Disclaimers:"),
                      ]),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-n4 pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("label", { staticClass: "page-sub-header" }, [
                        _vm._v(
                          "Transit times are approximated and may vary based on the origin, destination, and specific day of the week. Service days do not include day of pickup, weekends or holidays."
                        ),
                      ]),
                    ]
                  ),
                  _vm.showMap
                    ? _c(
                        "v-col",
                        {
                          staticClass: "pl-0",
                          attrs: {
                            xl: "9",
                            lg: "9",
                            md: "11",
                            sm: "12",
                            cols: "12",
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "br-10",
                            attrs: { width: "65%", src: _vm.mapSrc },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: {
                        xl: "9",
                        lg: "9",
                        md: "11",
                        sm: "12",
                        cols: "12",
                      },
                    },
                    [
                      _c("label", { staticClass: "carrier-numbers" }, [
                        _vm._v(_vm._s(_vm.transitTimes.length)),
                      ]),
                      _c("label", { staticClass: "ml-1 carrier-numbers-lbl" }, [
                        _vm._v("carrier results"),
                      ]),
                    ]
                  ),
                  _vm.transitTimesLoaded
                    ? _c(
                        "v-col",
                        {
                          staticClass: "pl-0 mt-n2",
                          attrs: {
                            xl: "9",
                            lg: "9",
                            md: "11",
                            sm: "12",
                            cols: "12",
                          },
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "img",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "hover",
                                                        attrs: {
                                                          src: _vm.ic_info_small,
                                                          width: "18",
                                                        },
                                                      },
                                                      "img",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3109455197
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Carrier service center terminal codes"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-n4 letter-code-wrap",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("label", { staticClass: "letter-code" }, [
                                    _vm._v("3 Letter Code"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._l(_vm.page, function (time) {
                return _c(
                  "v-row",
                  {
                    key: time.code + time.transitDays,
                    attrs: { justify: "center" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "pl-0",
                        attrs: {
                          xl: "9",
                          lg: "9",
                          md: "11",
                          sm: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-card",
                          { staticClass: "br-15", attrs: { elevation: "0" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-row",
                                  { staticClass: "mx-3 pt-3 pb-3" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          cols: "5",
                                          xl: "4",
                                          lg: "4",
                                          md: "4",
                                          sm: "5",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "est-service-lbl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Estimated Service: " +
                                                        _vm._s(
                                                          time.transitDays == 0
                                                            ? 1
                                                            : time.transitDays
                                                        ) +
                                                        " Day" +
                                                        _vm._s(
                                                          time.transitDays > 1
                                                            ? "s"
                                                            : ""
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          { attrs: { align: "center" } },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "auto" } },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "quote-carrier-logo mt-2",
                                                  attrs: {
                                                    src: _vm.path(
                                                      time.carrierName
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "8" } },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "carrier-name-lbl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(time.carrierName)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          { staticClass: "mt-n2" },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "carrier-service-lbl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Service Type: " +
                                                        _vm._s(
                                                          time.serviceType
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                            time.serviceType
                                                              .slice(1)
                                                              .toLowerCase()
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "mt-n7",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "carrier-service-desc-lbl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "(" +
                                                        _vm._s(
                                                          time.serviceType.toLowerCase() ==
                                                            "direct"
                                                            ? "Within region"
                                                            : "Outside region"
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pt-0",
                                        class: { "pr-0": _vm.smAndDown },
                                        attrs: {
                                          cols: "5",
                                          xl: "5",
                                          lg: "5",
                                          md: "5",
                                          sm: "7",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "pt-0",
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                class: {
                                                  "pb-0 pl-0": _vm.smAndDown,
                                                },
                                                attrs: {
                                                  cols: "12",
                                                  xl: "auto",
                                                  lg: "auto",
                                                  md: "auto",
                                                  sm: "12",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "bold-info",
                                                      },
                                                      [_vm._v("Pickup Date")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "mt-n6",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "just-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatDate(
                                                              _vm.pickupDate
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "transit-time-arrow",
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.ic_arrow_right,
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                class: {
                                                  "pb-0 pl-0": _vm.smAndDown,
                                                },
                                                attrs: {
                                                  cols: "12",
                                                  xl: "auto",
                                                  lg: "auto",
                                                  md: "auto",
                                                  sm: "12",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "bold-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Estimated Delivery Date"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "mt-n6",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "just-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.calcDeliveryDate(
                                                              time.transitDays
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            class: { "mt-0": _vm.smAndDown },
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                class: {
                                                  "pb-0 pl-0": _vm.smAndDown,
                                                },
                                                attrs: {
                                                  cols: "10",
                                                  xl: "5",
                                                  lg: "5",
                                                  md: "5",
                                                  sm: "10",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "bold-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Origin Terminal"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "mt-n5",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "bold-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            time.origTermCode
                                                          ) + " |"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "just-text ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.terminalAddress(
                                                              time,
                                                              "orig"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "transit-time-arrow",
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: _vm.ic_arrow_right,
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                class: {
                                                  "pb-0 pl-0": _vm.smAndDown,
                                                },
                                                attrs: {
                                                  cols: "10",
                                                  xl: "5",
                                                  lg: "5",
                                                  md: "5",
                                                  sm: "10",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-col",
                                                  { attrs: { cols: "12" } },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "bold-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Destination Terminal"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "mt-n5",
                                                    attrs: { cols: "12" },
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "bold-info",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            time.destTermCode
                                                          ) + " |"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "label",
                                                      {
                                                        staticClass:
                                                          "just-text ml-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.terminalAddress(
                                                              time,
                                                              "dest"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "transit-time-btn-wrapper",
                                        class: {
                                          "mt-16": _vm.mdAndUp,
                                          "my-3": _vm.smAndDown,
                                        },
                                        attrs: {
                                          xl: "3",
                                          lg: "3",
                                          md: "12",
                                          sm: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            attrs: {
                                              align: "center",
                                              justify: "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ta-c",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c("smart-btn", {
                                                  staticClass:
                                                    "transit-time-buttons",
                                                  attrs: {
                                                    type: "primary",
                                                    label: "create Quote",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ta-c",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c("smart-btn", {
                                                  staticClass:
                                                    "transit-time-buttons",
                                                  attrs: {
                                                    type: "primary",
                                                    label: "Create Shipment",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm.pagingLength > 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Transit Times"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }